module.exports = __webpack_public_path__ + "static/media/74.9e2a67a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/74.wav
// module id = o3nS
// module chunks = 0